import { render, staticRenderFns } from "./EditHolding.vue?vue&type=template&id=2e30cfbc&scoped=true"
import script from "./EditHolding.vue?vue&type=script&lang=ts"
export * from "./EditHolding.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e30cfbc",
  null
  
)

export default component.exports